export var ResidencyStatus;
(function (ResidencyStatus) {
    ResidencyStatus["AustralianCitizen"] = "AUSTRALIAN_CITIZEN";
    ResidencyStatus["PermanentResident"] = "PERMANENT_RESIDENT";
    ResidencyStatus["TemporaryResident"] = "TEMPORARY_RESIDENT";
    ResidencyStatus["Unknown"] = "UNKNOWN";
})(ResidencyStatus || (ResidencyStatus = {}));
//# sourceMappingURL=ResidencyStatus.js.map